var OffersTool = (function () {


  Utility.log('OffersTool loaded');
  var offersUi;
  var stockPhotoTimeout = null;
  var legacyRaq = !!(window.tools && window.tools.legacyRaq);

  var formatOfferDetailsModalDates = function (data) {
    // converts Offer-Details modal's Available-dates format,
    // from 'yyyy-mm-dd' to 'mmm dd, YYYY'.
    if (data.url.indexOf('/offer-details?') !== -1) {
      var startDateStrArr = data.event.item.offer.StartDate.split('-'); // [yyyy, mm, dd]
      var endDateStrArr = data.event.item.offer.EndDate.split('-'); // [yyyy, mm, dd]

      var dateStrsFormatted = {
        start: Utility.getMonthNameFromNumber(parseInt(startDateStrArr[1], 10)) + ' '
          + startDateStrArr[2].replace(/^0/, '') + ', ' + startDateStrArr[0],
        end: Utility.getMonthNameFromNumber(parseInt(endDateStrArr[1], 10)) + ' '
          + endDateStrArr[2].replace(/^0/, '') + ', ' + endDateStrArr[0],
      };

      $('.ui-modal-content .offer-detail-modal-dates-copy').text(
        dateStrsFormatted.start + ' - ' + dateStrsFormatted.end,
      );
    }
  };

  var formatOfferDetailsModalPrice = function (data) {
    if (data.url.indexOf('/offer-details?') !== -1) {
      var $modalPrice = $('.ui-modal-content .offer-detail-modal-price');
      var priceStr = $modalPrice.text().trim();

      $modalPrice.text(priceStr.replace(/\.\d\d$/, ''));
    }
  };

  var handleStockPhotos = function () {
    // Adds classhooks to image containers to handle offer-specific, stock
    // images from API, when window.offer.stockPhoto var specifies this for a
    // tab.
    var stockPhoto;
    var $stockPhotoOffersContainer;
    var $stockPhotoImgContainers;

    if (window.offers.stockPhoto) {
      stockPhoto = window.offers.stockPhoto;

      if (stockPhotoTimeout) {
        clearTimeout(stockPhotoTimeout);
        stockPhotoTimeout = null;
      }

      if (stockPhoto.showStockPhoto) {
        $stockPhotoOffersContainer = $('.offers-container[offer-type=' + stockPhoto.stockPhotoTab + ']');
        $stockPhotoImgContainers = $stockPhotoOffersContainer.find('.offers-group-model-container');
        if ($stockPhotoImgContainers.length > 0) {
          $stockPhotoImgContainers.addClass('stock-photo');
        } else {
          console.warn('No image containers found!');
        }
      }
    } else {
      stockPhotoTimeout = setTimeout(function () {
        handleStockPhotos();
      }, 250);
    }
  };

  var reevalPicturefills = function () {
    // ie11 workaround:
    // re-evaluates images (with srcset attr) inside picture elements,
    // using picturefill.min.js.
    var $srcsetImages = $('.ui-modal-content picture img[srcset]:not(.interpolated)');

    if ($srcsetImages.length > 0) {
      picturefill({
        reevaluate: true,
        elements: $srcsetImages,
      });
    }
  };

  var prefixV2Images = function (images) {
    // All images with the string "acura2" in their path
    // are V2.0 images that need to be prefixed with "assets/"
    // This should be checked when the endpoint data is loaded
    // and when a model is selected and the feature offer image changes.
    for (var i = 0; i < images.length; i++) {
      var acura2Pos = images[i].src.indexOf('acura2');
      var assetsPos = images[i].src.indexOf('assets/');

      if (acura2Pos !== -1 && assetsPos === -1) {
        images[i].src = images[i].src.slice(0, acura2Pos) + 'assets/'
            + images[i].src.slice(acura2Pos);
      }
    }
  };

  var checkV2Images = function () {
    var vehicleImages = document.querySelectorAll('.offers-vehicle-image');

    prefixV2Images(vehicleImages);
  };

  var getText = function (url, offer) {
    // NOTE: Tokens should be part of the base url on CMS
    var replacements = url.match(/\[%%[\d\D]*?%%]/g);

    if (replacements) {
      replacements.forEach(function (match) {
        url = url.replace(match, offer[match.slice(3, -3).toLowerCase()]);
      });
    }

    return url;
  };

  var setListeners = function () {
    // once data is loaded initialize everything
    offersUi.bus.on(offersUi.bus.EVENTS.DATA.DATA_LOADED, function () {
      SelectBox.createSelect('.vehicle-dropdown-select');
      SelectBox.createSelect('.offers-filter-select');

      setTimeout(function () {
        handleStockPhotos();
      }, 500);

      checkV2Images();
    });

    offersUi.bus.on(offersUi.bus.EVENTS.MODAL.MODAL_LOADED, function (data) {
      // must be RAQ
      if (data.event === undefined) {
        // Deleting sessionStorage bapAccessories
        if (!window.BaP) {
          sessionStorage.removeItem('bapAccessories');
        }
        RaqTool.initRaq('.ui-modal-content');
        $('body').addClass('modal-open');
        $('offers-modal-wrapper').addClass('modal-raq');
      }
      if (data.url.indexOf('/offer-details?') !== -1) {
        formatOfferDetailsModalDates(data);
        formatOfferDetailsModalPrice(data);
        if (Utility.isIE11()) {
          reevalPicturefills();
        }
      }
    });

    offersUi.bus.on(offersUi.bus.EVENTS.MODAL.MODAL_IS_CLOSING, function () {
      $('body').removeClass('modal-open');
      $('offers-modal-wrapper').removeClass('modal-raq');
    });

    offersUi.bus.on(offersUi.bus.EVENTS.MODEL.CHANGE, function (data) {
      // trigger an update to the dropdown when the model is changed
      //  (could be changed via dropdown or the "All ILX Offers" CTA)
      try {
        // This initialization sometimes throws an exception that
        // prevents the riot event (model.change) from working from that point on
        // and checkV2Images from being called when the model changes.
        SelectBox.setInitialValue('input-vehicle-clone', data.newValue);
      } catch (err) {
        console.error(err);
      }

      checkV2Images();
    });

    // handle special offers modal RAQ CTA click
    $(document).on('click', '.offer-detail-modal-cta.raq-cta', function (e) {
      e.preventDefault();

      if (legacyRaq) {
        window.open(e.target.href, 'acura');
      } else {
        offersUi.bus.trigger(offersUi.bus.EVENTS.MODAL.MODAL_OPEN, {
          url: e.target.href,
        });
      }
    });

    // handle "all [model] offers" cta when filtering "all vehicles" on the featured tab
    $(document).on('click', '.offers-group-model-filter', function () {
      window.scrollTo(0, 0);
    });
  };

  var init = function () {
    // sitecoreExpEditor is used to avoid init the app
    // when on Sitecore experience editor
    var sitecoreExpEditor = !!(window.Sitecore
                    && window.Sitecore.WebEditSettings
                    && window.Sitecore.WebEditSettings.editing);
    if ($('offers-wrapper').length > 0 && !sitecoreExpEditor) {
      offersUi = window.platform.offers.default.init();

      setListeners();
    }
  };

  // Listen for DOM changes and check the images prefixes when they happen
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  if (MutationObserver) {
    var target = document.querySelector('offers-wrapper');
    if (target) {
      var observer = new MutationObserver(function () {
        checkV2Images();
      });
      var config = { attributes: true, childList: true, subtree: true };

      observer.observe(target, config);
    }
  }

  return {
    init: init,
  };
}());
